import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './langs/en.json';
import es from './langs/es.json';

i18n.use(initReactI18next).init({
    lng: 'es',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    resources: {
        en: {
            translation: en
        },
        es: {
            translation: es
        }
    }
});

export default i18n;
